import { render, staticRenderFns } from "./ForeignAgentEmail.vue?vue&type=template&id=892d9dfa&"
import script from "./ForeignAgentEmail.vue?vue&type=script&lang=js&"
export * from "./ForeignAgentEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('892d9dfa')) {
      api.createRecord('892d9dfa', component.options)
    } else {
      api.reload('892d9dfa', component.options)
    }
    module.hot.accept("./ForeignAgentEmail.vue?vue&type=template&id=892d9dfa&", function () {
      api.rerender('892d9dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/foreign-agent/ForeignAgentEmail.vue"
export default component.exports